import { Component } from '@grafikr/components';

export default Component((node, { onMounted }) => {
  onMounted(() => {
    const anchorLinks = document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]');
    anchorLinks.forEach((anchor) => {
      if (anchor.dataset.dontScroll) {
        return;
      }
  
      anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const elem = document.querySelector<HTMLElement>(this.getAttribute('href'));
        if (elem) {
          window.scrollTo({
            top: elem.offsetTop,
            behavior: 'smooth',
          });
        }

        if (anchor.dataset.openFaq) {
          const faqToOpen = document.querySelector<HTMLElement>(`[data-voyado-faq-item="${anchor.dataset.openFaq}"]`);
          if (faqToOpen) {
            faqToOpen.click();
          }
        }
      });
    });
  });
});
